import { render } from "./FormSelect.vue?vue&type=template&id=46990dab"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__